import styled from "styled-components"

const Section = styled.section`
  min-height: 10vh;
  background-image: url('/images/backgroundgradient.png?height=460&width=1920');
  background-size: cover;
  background-position: center;
  padding: 1rem;

  @media (min-width: 768px) {
    padding: 2rem;
  }
`

const Container = styled.div`
  max-width: 72rem;
  margin: 0 auto;
`

const Content = styled.div`
  display: grid;
  align-items: center;
  gap: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 768px) {
    padding-right: 3rem;
  }
`

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: bold;
  color: #6b8aff;

  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
`

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  list-style-type: none;
  padding: 0;
`

const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
`

const Bullet = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  background-color: white;
  transform: rotate(45deg);
`

const ImageContainer = styled.div`
  position: relative;
  height: 300px;
  margin-left: -1rem;

  @media (min-width: 768px) {
    height: 400px;
    margin-left: 0;
  }
`

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`

function WorkProcess() {
  return (
    <Section>
      <Container>
        <Content>
          <TextContent>
            <Title>Services Offers :</Title>
            <List>
              <ListItem>
                <Bullet />
                <span>Artwork Management</span>
              </ListItem>
              <ListItem>
                <Bullet />
                <span>Label Design & Development</span>
              </ListItem>
              <ListItem>
                <Bullet />
                <span>Packaging Design & Development</span>
              </ListItem>
              <ListItem>
                <Bullet />
                <span>Sustainable Packaging Development</span>
              </ListItem>
              <ListItem>
                <Bullet />
                <span>Cost Saving Solution</span>
              </ListItem>
              <ListItem>
                <Bullet />
                <span>Vendor Management</span>
              </ListItem>
            </List>
          </TextContent>
          <ImageContainer>
            <Image
              src="/images/workprocess.png"
              alt="Packaging design illustration"
            />
          </ImageContainer>
        </Content>
      </Container>
    </Section>
  )
}

export default WorkProcess

